/**
 * Only the latest request paints (CU-869fmhmx8 D12). A cancelled or superseded request may still answer or fail
 * (and `postSubmit` retries what fails): anything that is not the latest is ignored, and a cancel is never an error.
 */
export function createLatestGate() {
	let last = 0
	return {
		next: () => ++last,
		isLatest: id => id === last,
	}
}

export const isAbortError = e => e?.name === 'AbortError'

/** Whether an outcome of request `id` may reach the screen; errors from a cancel never do */
export const shouldPaint = (gate, id, error = null) => gate.isLatest(id) && !isAbortError(error)

/**
 * Whether the screen shows something that is not the answer to the view asked (QA): from the moment the view changes
 * (the wait before the request included) until its own answer — or its own error — arrives. A late answer to the
 * previous view never ends it: the hook stamps each outcome with the view it answers (`dataKey`, `errorKey`).
 */
export const isPending = ({ key, dataKey = null, errorKey = null, loading = false }) =>
	!!key && (loading || (dataKey !== key && errorKey !== key))
